export default __webpack_public_path__ + "static/media/neck_base.8fe0597b.svg";